<app-payment-required
	*ngIf="paymentRequired; else canOpenFiles"
	class="modal"
	[type]=""
	[fileType]="fileType"
	(onReset)="resetModal()"
></app-payment-required>
<ng-template #canOpenFiles>
	<div class="modal">
		<ui-content-header [title]="title" type="dialog">
			<div actions>
				<ui-button icon="x" preset="ICON_DEFAULT" (click)="close()" />
			</div>
		</ui-content-header>
		<app-matter-file-type-select
			*ngIf="currentStep == 0"
			(fileTypeSelected)="setFileType($event)"
		></app-matter-file-type-select>
		<app-create-modal-details-step
			*ngIf="currentStep === 1"
			[matterType]="fileType"
			(goBack)="goBack()"
			(onCreate)="onCreateFile($event)"
			(onClose)="close()"
		></app-create-modal-details-step>
		<app-upload-documents-modal-step
			*ngIf="currentStep === 2"
			[matterId]="matterId"
			[matterType]="fileType"
			(onFinish)="handleUpload()"
		></app-upload-documents-modal-step>
	</div>
</ng-template>
